'use strict';

const $sectionVisualSlide = document.querySelector('.section-visual-slide');
if ($sectionVisualSlide) {
  let $numbering = $sectionVisualSlide.querySelector('.section-visual-slide__numbering');
  let $numberingCurrent = $numbering.querySelector(':scope > .is-current');
  let $numberingTotal = $numbering.querySelector(':scope > .is-total');
  let $visual = document.querySelector('.section-visual');
  let slideNumberingIndex = () => {
    $numberingCurrent.textContent = splide.index + 1;
    $numberingTotal.textContent = splide.length;
  };
  let visibleCopy = () => {
    if ($visual) {
      let $active = $sectionVisualSlide.querySelector('.section-visual-slide__lists__item.is-active');
      let $link = $active.querySelector('.is-link');
      let $visualCopy = $visual.querySelector('.section-visual-copy');
      if ($link) {
        $visualCopy.classList.add('is-hidden');
      } else {
        $visualCopy.classList.remove('is-hidden');
      };
    };
  };
  let option = {
    type: 'loop',
    focus: 'center',
    fixedWidth: '100%',
    gap: 0,
    speed: 800,
    autoplay: 'true',
    interval: 4000,
    easing: 'ease-in-out',
    arrows: true,
    pagination: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    drag: true
  };
  let splide = new Splide($sectionVisualSlide, option);
  splide.mount();
  splide.on('active', () => {
    slideNumberingIndex();
  });
  splide.on('moved', () => {
    visibleCopy();
  });
  slideNumberingIndex();
};